import { render, staticRenderFns } from "./DokuWikiWrapperReactivity.vue?vue&type=template&id=6f024000"
import script from "./DokuWikiWrapperReactivity.vue?vue&type=script&setup=true&lang=ts"
export * from "./DokuWikiWrapperReactivity.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports